/* eslint-disable react/no-array-index-key */
import {
  convertAirbags,
  convertValueToText,
  getConvertedValue,
// eslint-disable-next-line @stylistic/max-len
} from '../../../../_components/page-content/submodel-list/mobile/submodel-info-table/features-info/utils';
import { Accordion } from '../accordion';
import styles from './styles.module.scss';
import type { Component } from './types';

export const FeaturesTable: Component = ({
  compareList,
}) => (
  <>
    <Accordion
      title="LIGHTING"
      defaultOpen>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Head Lights
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-head-lights`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.headLights,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-head-lights`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Daytime Running Lights
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-daytime-running-lights`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.daytimeRunningLights,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-daytime-running-lights`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Auto Head Lights
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-auto-head-lights`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.autoHeadlights,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-auto-head-lights`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="EXTERIOR">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Electric Folding Side Mirrors
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-side-mirrors`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.autoHeadlights,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-side-mirrors`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Rain Sensing Wipers
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-rain-sensing-wipers`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.rainSensingWipers,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-rain-sensing-wipers`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="INTERIOR">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Multi-function Steering Wheel
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-control-on-steering-wheel`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.controlOnSteeringWheel,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-control-on-steering-wheel`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Paddle Shifters
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-paddle-shifters`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.paddleShifters,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-paddle-shifters`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Keyless Entry
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-smart-key`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.smartKey,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-smart-key`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Keyless Engine Start
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-push-start-engine`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.pushStartEngine,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-push-start-engine`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Multi-zone Aircon
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-dual-zone-aircon`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.dualZoneAc,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-dual-zone-aircon`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Rear Aircon
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-rear-aircon`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.rearAircon,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-rear-aircon`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Seat Upholstery
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-seat-upholstery`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.seatUpholstery,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-seat-upholstery`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Sunroof/Moonroof/Panoramic Roof
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-sunroof-moonroof-skyroof`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.sunroofMoonroofSkyroof,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-sunroof-moonroof-skyroof`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="COMFORT & CONVENIENCE">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Driver&apos;s Electric Seat
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-driver-electric-seat`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'driverElectricSeats',
                  item.subModels[0]?.features.driverElectricSeat,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-driver-electric-seat`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Passenger&apos;s Electric Seat
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-passenger-electric-seat`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'driverElectricSeats',
                  item.subModels[0]?.features.passengerElectricSeat,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-passenger-electric-seat`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Ventilated Seats
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-ventilated-seat`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'ventilatedSeats',
                  item.subModels[0]?.features.ventilatedSeats,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-ventilated-seat`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Knockdown Rear Seats
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-knockdown-rear-seats`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.knockdownRearSeats,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-knockdown-rear-seats`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Electric Tailgate
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-electric-tailgate`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.electricTailgate,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-electric-tailgate`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Electric Sliding Door
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-electric-sliding-door`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'electricSlidingDoor',
                  item.subModels[0]?.features.electricSlidingDoor,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-electric-sliding-door`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="INFOTAINMENT SYSTEM">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Bluetooth
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-bluetooth`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.bluetoothInterface,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-bluetooth`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Apple CarPlay
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-apple-car-play`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'carPlay',
                  item.subModels[0]?.features.appleCarPlay,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-apple-car-play`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Android Auto
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-android-auto`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'carPlay',
                  item.subModels[0]?.features.androidAuto,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-android-auto`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Wireless Smartphone Charging
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-wireless-smartphone-charging`}
                className={`${styles.containerScrollCell}`}>
                {
                  convertValueToText(
                    item.subModels[0]?.features.wirelessSmartPhoneCharging,
                  )
                }
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-wireless-smartphone-charging`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Navigation System
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-navigation-system`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.navigationSystem,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-navigation-system`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Heads-up Display
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-head-up-display`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(item.subModels[0]?.features.headUpDisplay)}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-head-up-display`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Infotainment
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-infotainment`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.touchscreenDisplay,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-infotainment`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Sound System
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-sound-system`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.soundSystem,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-sound-system`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="SAFETY & LOCKS">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        No. of Airbags
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-airbags`}
                className={`${styles.containerScrollCell}`}>
                {convertAirbags(
                  item.subModels[0]?.features.airbags,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-airbags`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Isofix
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-isofix`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(item.subModels[0]?.features.isofix)}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-isofix`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Tyre Pressure Monitor
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-tyre-pressure-monitor`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.tyrePressureMonitor,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-tyre-pressure-monitor`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="BRAKES & SUSPENSION">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Electric Park Brake
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-electric-park-brake`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'electricParkBrake',
                  item.subModels[0]?.features.electricParkBrakeButton,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-electric-park-brake`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Hill Start Assist
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-hill-start-assist`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.hillStartAssist,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-hill-start-assist`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Emergency Brake Assist
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-emcy-brake-assist`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(
                  item.subModels[0]?.features.emcyBrakeAssist,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-emcy-brake-assist`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="DRIVING ASSISTANCE">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Cruise Control
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-cruise-control`}
                className={`${styles.containerScrollCell}`}>
                {
                  getConvertedValue(
                    'cruiseControl',
                    item.subModels[0]?.features.cruiseControl,
                  )
                }
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-cruise-control`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Lane Keep Assist
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-lane-keep-assist`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(item.subModels[0]?.features.laneKeepAssist)}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-lane-keep-assist`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Lane Departure Warning
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-lane-dep-warning`}
                className={`${styles.containerScrollCell}`}>
                {convertValueToText(item.subModels[0]?.features.laneDepWarning)}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-lane-dep-warning`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Blind Spot Monitor
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-blind-spot-monitor`}
                className={`${styles.containerScrollCell}`}>
                {
                  getConvertedValue(
                    'blindSpotMonitor',
                    item.subModels[0]?.features.blindSpotMonitor,
                  )
                }
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-blind-spot-monitor`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Parking Sensors
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-reverse-sensors`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'parkingSensors',
                  item.subModels[0]?.features.reverseSensors,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-reverse-sensors`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Reverse Camera
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                key={`${item.subModels[0]?.id}-reverse-camera`}
                className={`${styles.containerScrollCell}`}>
                {getConvertedValue(
                  'reverseCamera',
                  item.subModels[0]?.features.reverseCamera,
                )}
              </div>
            );
          }
          return (
            <div
              key={`null-${i}-reverse-camera`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="ADDITIONAL FEATURES">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Additional Features
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                dangerouslySetInnerHTML={{
                  __html: item.subModels[0]?.features.additionalFeatures
                    ? item.subModels[0]?.features.additionalFeatures
                    : '-',
                }}
                key={`${item.subModels[0]?.id}-additional-features`}
                className={`${styles.containerScrollCell}`} />
            );
          }
          return (
            <div
              key={`null-${i}-additional-features`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
    <Accordion
      title="REMARKS">
      <div
        className={`${styles.containerStickyRow} ${styles.textLabel}`}>
        Remarks
      </div>
      <div className={`${styles.containerRow}`}>
        {compareList.map((item, i) => {
          if (item !== null) {
            return (
              <div
                dangerouslySetInnerHTML={{
                  __html: item.subModels[0]?.features.remarks
                    ? item.subModels[0]?.features.remarks
                    : '-',
                }}
                key={`${item.subModels[0]?.id}-remarks`}
                className={`${styles.containerScrollCell}`} />
            );
          }
          return (
            <div
              key={`null-${i}-remarks`}
              className={`${styles.containerScrollCell}`}>
              -
            </div>
          );
        })}
      </div>
    </Accordion>
  </>
);
